function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.25 13.5H2.75C2.3125 13.5 2 13.8125 2 14.25C2 14.6875 2.3125 15 2.75 15H13.25C13.6562 15 14 14.6875 14 14.25C14 13.8438 13.6562 13.5 13.25 13.5ZM11.4375 6.5L8.75 9.375V1.78125C8.75 1.34375 8.40625 1 8 1C7.5625 1 7.25 1.34375 7.25 1.78125V9.375L4.53125 6.5C4.375 6.34375 4.1875 6.28125 4 6.28125C3.8125 6.28125 3.625 6.34375 3.46875 6.46875C3.15625 6.75 3.15625 7.21875 3.4375 7.53125L7.4375 11.7812C7.71875 12.0938 8.25 12.0938 8.53125 11.7812L12.5312 7.53125C12.8125 7.21875 12.8125 6.75 12.5 6.46875C12.1875 6.1875 11.7188 6.1875 11.4375 6.5Z",
  fill: "#767B87"
});

const SvgDownloadHtml = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDownloadHtml, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download_html.1ca74fdf.svg";
export { ForwardRef as ReactComponent };